import mapValues from 'lodash/mapValues';
import isArray from 'lodash/isArray';
import isString from 'lodash/isString';
import isEmpty from 'lodash/isEmpty';
import toString from 'lodash/toString';
import includes from 'lodash/includes';
import moment from 'moment';
import { isNil, omit, pick } from 'lodash';
import { carrierKeys, documentKeys } from 'store/utils';
import { debounce } from 'lodash';
import { saveTaskFlag } from 'store/forms/actions';

export const logoutUrl = `${window.location.protocol}//${window.location.hostname}${process.env.REACT_APP_BACKEND_HOST_PORT}/${process.env.REACT_APP_FLOWABLE_CONTEXT_PATH}/exit`;
export const redirectUrl = `${window.location.protocol}//${window.location.hostname}${process.env.REACT_APP_APPTRACK_PORT}/${process.env.REACT_APP_FLOWABLE_CONTEXT_PATH}/workflow/appTrack`;
export const mainFormsUrl = task => {
  return `${window.location.protocol}//${window.location.hostname}${process.env.REACT_APP_BACKEND_HOST_PORT}/${process.env.REACT_APP_FLOWABLE_CONTEXT_PATH}/workflow/forms/task/${task}`;
};
export const viewUrl = task => {
  return `${window.location.protocol}//${window.location.hostname}${process.env.REACT_APP_BACKEND_HOST_PORT}/${process.env.REACT_APP_FLOWABLE_CONTEXT_PATH}/appTrack#/view/${task}`;
};

export const dateFormat = 'DD/MM/YYYY';

export const getFullDate = date => {
  if (typeof date === 'undefined') {
    return '-';
  } else {
    const dateAndTime = date.split('T');

    return dateAndTime[0];
  }
};

export const isInvestor = privileges =>
  !isEmpty(privileges) && privileges.includes('isBeneficiary');
export const isBeneficiary = groups =>
  !isEmpty(groups) && groups.some(group => includes(group.id, 'Beneficiary'));
export const isCoe = groups =>
  !isEmpty(groups) && groups.some(group => includes(group.id, 'AUDITOR'));
export const isSubmitter = privileges =>
  !isEmpty(privileges) && privileges.includes('isCommittee');
export const isObjectionCommittee = privileges =>
  !isEmpty(privileges) && privileges.includes('isObjectionCommittee');
export const isAuditor = key => key === 'auditor' || key === 'auditor_2';
export const isEditor = groups =>
  !isEmpty(groups) && groups.some(group => includes(group.id, 'EDITOR'));
export const isKtP = groups =>
  !isEmpty(groups) && groups.some(group => group.id === 'KTP');
export const isProvider = groups =>
  !isEmpty(groups) && groups.some(group => group.id === 'ProviderResourceGroup');
export const isAdminUser = groups =>
  !isEmpty(groups) && groups.some(group => group.id === 'AdminResourceGroup');
export const isUserStore = groups =>
  !isEmpty(groups) && groups.some(group => group.id === 'Store');
export const isMinistry = groups =>
  !isEmpty(groups) && groups.some(group => group.id === 'Ministry');
export const isSuperUser = groups => 
  !isEmpty(groups) && groups.some(group => group.id === 'SYSTEM_ADMINISTRATOR');
export const isUserAbleToSubmit = (formKey, groups) =>
  isInvestor(groups) ||
  (!isInvestor(groups) &&
    (isSubmitter(groups) || !(isEditor(groups) && !isSubmitter(groups))));

export const outcomes = {
  saveBeneficiary: 'Αποθήκευση',
  submitBeneficiary: 'submission',
  cancelBeneficiary: 'cancel',
  evaluationRejection: 'evaluationRejection',
  evaluationApproval: 'evaluationApproval',
  returnToCoe: 'returntocoe'
};

export const isViewformDisabled = (loc) => loc.includes('disabled') ? true : false;

export const handleThirdPartyValidations = async ({
  state,
  user,
  dispatch,
  thirdPartyValidations,
}) => {
  let payload = {};

  const afm = user?.taxis_data?.afm;

  payload = {
    "afm": afm,
    "phoneNumber": state?.carrier?.connNum || "",
    "kad": isBeneficiary(user?.groups) && state?.carrier?.mainKAD ? state?.carrier?.mainKAD : "0",
    "sorefsisAmount": state?.carrier?.totalAmountSorefsis,
    "kaek": state?.carrier?.kaek || "0",
    "isNp": isBeneficiary(user?.groups),
    "procInstId": state?.task?.processInstanceId || "",
  }

  const response = await dispatch(thirdPartyValidations(payload));
  return response;
};

export const handleSave = ({ state, dispatch, saveTask, taskId, formId, isSaved }) => {
  const carrier = { ...state.carrier };
  // console.log("carrier2:",carrier.investmentFinancing);
  const documents = { ...state.documents };
  const terms = { ...state.terms };
  const XEDM = { ...state.XEDM };

  const parsedDocs = mapValues(
    documents,
    doc =>
      isArray(doc) // case of multiple documents (array of objects)
        ? toString(doc.map(d => d.id))
        : !isNil(doc) && isString(doc) // case of radio buttons inside document form
          ? doc
          : !isNil(doc)
            ? doc.id
            : '' // case of single documents (object)
  );

  const payload = {
    values: {
      ...pick(parsedDocs, documentKeys(parsedDocs)),
      ...pick(carrier, carrierKeys(carrier)),
      ...XEDM,
      ...terms,
      isSaved,
    },
    formId,
    taskId,
  };

  // console.log({parsedDocs});
  // console.log({payload});
  dispatch(saveTask(payload));
};

export const handleFlagUpdate = ({ dispatch, successFlag, finishFlag, formId, taskId }) => {


  const payload = {
    values: {
      successFlag: successFlag,
      finishFlag: finishFlag
    },
    formId,
    taskId,
  };

  console.log("payload", payload)
  dispatch(saveTaskFlag(payload));
};

export const handleSaveUpdate = ({ dispatch, documents, formId, taskId, saveTaskUpdate }) => {


  const parsedDocs = mapValues(
    documents,
    doc =>
      isArray(doc) // case of multiple documents (array of objects)
        ? toString(doc.map(d => d.id))
        : !isNil(doc) && isString(doc) // case of radio buttons inside document form
          ? doc
          : !isNil(doc)
            ? doc.id
            : '' // case of single documents (object)
  );

  const payload = {
    values: {
      ...pick(parsedDocs, documentKeys(parsedDocs)),
    },
    formId,
    taskId,
  };

  console.log("payload", payload)

  // console.log({parsedDocs});
  // console.log({payload});
  dispatch(saveTaskUpdate(payload));
};

export const handleSubmit = ({
  state,
  variablesIndexed,
  user,
  dispatch,
  submitTask,
  navigate,
  taskId,
  activeTaskName,
  procInstId,
  outcome,
  setErrorModal,
  setErrorMessages,
  task,
  rejectMessage,
  modal
}) => {
  const carrier = { ...state.carrier };
  const documents = { ...state.documents };
  const terms = { ...state.terms }
  // const reject = state?.reject;
  const isSaved = true;
  const isUserKTP = (user.groups?.filter(a => a.id.startsWith("KTP")).length > 0) ? (user.groups?.filter(a => a.id.startsWith("KTP")).length > 0) : false;
  // Document payload should be string of id for single items (e.g. ibaStockRev: '32432fdw34') and string of csv ids for multiple items (e.g. ibaStockRev: '83293few2342,3943fe234,2131hfe3')
  const parsedDocs = mapValues(
    documents,
    doc =>
      isArray(doc) // case of multiple documents (array of objects)
        ? toString(doc.map(d => d.id))
        : !isNil(doc) && isString(doc) // case of radio buttons inside document form
          ? doc
          : !isNil(doc)
            ? doc.id
            : '' // case of single documents (object)
  );

  let payload = isUserKTP ?
    {
      task,
      // formId,
      taskId,
      navigate,
      setErrorModal: setErrorModal,
      setErrorMessages: setErrorMessages,
      values: {
        isSaved,
        ...pick(carrier, carrierKeys(carrier)),
        // ...parsedDocs,
        ...terms,
        documents: { ...documents },
      }
    }
    :
    {
      task,
      // formId,
      taskId,
      navigate,
      modal: modal,
      setErrorModal: setErrorModal,
      setErrorMessages: setErrorMessages,
      values: {
        isSaved,
        taskId: taskId,
        activeTaskName: activeTaskName,
        procInstId: procInstId,
        ...pick(carrier, carrierKeys(carrier)),
        ...pick(parsedDocs, documentKeys(parsedDocs)),
        ...terms,
        ...omit(variablesIndexed, ['coeEmail']),
        documents: { ...documents },
        // modalAfterSubmit: true,
        ...(outcome === outcomes.returnToCoe && { returnMessage: rejectMessage }),
        ...(outcome === outcomes.evaluationRejection && { message: rejectMessage }),
      }
    };

  // console.log({task})
  //different variable names for outcomes of different tasks based on modeler
  let outcomeForModeler;
  switch (task?.taskName) {
    case 'task.name.submit_application':
      outcomeForModeler = {
        flow_submit_outcome: outcome,
      };
      break;
    case 'task.name.audit_application':
      outcomeForModeler = {
        flow_audit_outcome: outcome,
      };
      break;
    case 'task.name.application_evaluation':
      outcomeForModeler = {
        flow_evaluation_outcome: outcome,
      };
      break;
    case 'task.name.application_evaluated':
      outcomeForModeler = {
        flow_evaluated_outcome: outcome,
      };
      break;
    case 'task.name.program_implementation_complete':
      outcomeForModeler = {
        flow_program_outcome: outcome,
      };
      break;
    case 'task.name.submit_objection':
      outcomeForModeler = {
        flow_objection_outcome: outcome,
      };
      break;
    case 'task.name.complete_application_request': //maybe this one won't be needed in the front
      outcomeForModeler = {
        flow_payment: outcome,
      };
      break;
    default:
      outcomeForModeler = {};
  }

  payload = {
     ...payload,
     values: { 
      ...payload.values,
      ...outcomeForModeler,
      ...(isCoe(user?.groups) && { coeEmail: user?.email })
     }
  };

  console.log({ payload })
  // console.log({reject})
  // console.log({state})
  // console.log({user})
  dispatch(submitTask(payload));
};


export const handleReturn = ({
  state,
  dispatch,
  rejectTask,
  taskId,
  formId,
  formKey,
  outcome,
}) => {
  handleSubmit({
    state,
    dispatch,
    rejectTask,
    taskId,
    formId,
    formKey,
    outcome,
  });
};

// Required fields for Documents
export const isDocumentValid = (user, documents, carrier) => {
  if (
    documents.declarMME &&
    documents.declarBeneficiary &&
    documents.dataPrint &&
    (carrier?.existCon !== false ? documents.accNum : true) &&
    documents.declarSorefsis
  ) {
    return true;
  }
};

export const isCarrierValid = (carrier) => {
  if (
    //2.1
    // validAbiGcrCode(carrier?.abiGcrCode, carrier?.companyLegalType) &&
    // carrier?.abiGcrCode &&
    carrier?.companyName &&
    validAFM(carrier?.abiVat) &&
    carrier?.mainKAD &&
    // carrier?.mainKADDescription &&
    carrier?.companyLegalType &&
    carrier?.companySize &&
    carrier?.abiStreetFull &&
    carrier?.abiTk &&
    carrier?.abiPerfecture &&
    carrier?.abiDistrict &&
    carrier?.invMob &&

    //2.2
    carrier?.buildAddress &&
    carrier?.buildStreet &&
    carrier?.buildCity &&
    carrier?.buildTk &&
    carrier?.buildPerfecture &&//buildPerfecture: 
    // XEDM?.details?.kaek &&  //kaek
    ((carrier?.existCon === true && validPhoneNumber(carrier.connNum, false, true)) || carrier?.existCon === false) &&

    //sorefsis
    (process.env.REACT_APP_BYPASS_SOREFSIS || (!isNil(carrier?.totalAmountSorefsis) && carrier?.totalAmountSorefsis + parseFloat(process.env.REACT_APP_GIG_SOREFSIS) <= process.env.REACT_APP_SOREFSIS_AMOUNT)) &&
    carrier?.rejectReasons?.isSubmitValid !== false

  ) {
    //2.3
    if (carrier.contactPersonFlag === false) {
      if (
        !(
          carrier?.contactSurname &&
          carrier?.contactName &&
          validAFM(carrier?.contactVat) &&
          validPhoneNumber(carrier?.contactPhone, true) &&
          carrier?.contactPhoneValidated &&
          validEmail(carrier?.contactEmail) &&
          carrier?.contactEmailValidated
        )
      ) {
        return false;
      }
    } else {
      if (
        !(
          carrier?.legalSurname &&
          carrier?.legalName &&
          validAFM(carrier?.legalVat) &&
          validPhoneNumber(carrier?.legalPhone, true) &&
          carrier?.legalPhoneValidated &&
          validEmail(carrier?.legalEmail) &&
          carrier?.legalEmailValidated
        )
      ) {
        return false;
      }

    }

    return true;
  }
  return false;
};

export const isTermsValid = (terms) => {
  if (
    //tab Τήρηση Προϋποθέσεων Συμμετοχής
    terms?.terms0 &&
    terms?.terms1 &&
    terms?.terms2 &&
    terms?.terms3 &&
    terms?.terms4 &&
    terms?.terms5 &&
    terms?.terms6 &&
    terms?.terms7 &&
    terms?.terms8 &&
    terms?.terms9 &&
    terms?.terms10 &&
    terms?.terms11 &&
    terms?.terms12 &&
    terms?.terms13 &&
    terms?.terms14 &&
    terms?.terms15
  ) {
    return true;
  }
  return false;
};

export const handleSubmitDisabled = ({ user, state, formKey }) => {
  const {
    carrier,
    documents,
    XEDM,
  } = state;

  if (
    isCarrierValid(carrier, XEDM) &&
    isDocumentValid(user, documents, carrier)
  ) {
    return false;
  }

  return true;
}

export const handleCheckUniqueness = async ({
  state,
  user,
  dispatch,
  checkUniqueness,
}) => {
  let payload = {};

  const afm = user?.taxis_data?.afm;

  payload = {
    "afm": afm
  }

  const response = await dispatch(checkUniqueness(payload));
  return response;
};

export const validEmail = email => {
  var mailformat = /^\w+([.-]?\w+)*@[a-zA-Z0-9.-]+(\.[a-zA-Z]{2,3})+$/;
  var valid = false;
  if (email !== null && email!==undefined && email.match(mailformat)) {
    valid = true;
  }
  return valid;
};

export const validDateStart = value => {
  const formattedValue = isString(value) ? moment(value) : value;
  let valid = true;

  if (value) {
    if (formattedValue.isBefore(new Date(new Date().valueOf()))) {
      valid = false;
    }
  } else {
    valid = false;
  }

  return valid;
};

export const validWebSite = website => {
  var valid = false;

  if (isEmpty(website)) {
    return true;
  }
  var webFormat = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$',
    'i'
  ); // fragment locator
  if (website !== null && website.match(webFormat)) {
    valid = true;
  }
  return valid;
};

export const validTk = tk => {
  var valid = false;

  if (!isNil(tk) && tk.length !== 5) {
    valid = false;
  } else {
    valid = true;
  }

  return valid;
};

export const validateTk = tk => {
  var valid = false;

  if (tk.length !== 5) {
    valid = false;
  } else {
    valid = true;
  }
  return valid
    ? Promise.resolve()
    : Promise.reject('Ο Τ.Κ θα πρέπει να είναι 5 ψηφία.');
};

export const validAFM = afm => {
  if (afm && afm.length !== 9) {
    // "Τα ψηφία του ΑΦΜ πρέπει να είναι 9 αριθμοί"
    return false;
  }

  if (!/^\d+$/.test(afm)) {
    // "Αυτό που εισάγετε δεν είναι αριθμός"
    return false;
  }

  if (afm === '0'.repeat(9)) {
    // "Αυτό που εισάγετε είναι μηδενικός αριθμός (000000000)"
    return false;
  }

  const sum = afm
    .substring(0, 8)
    .split('')
    .reduce((s, v, i) => s + (parseInt(v) << (8 - i)), 0);

  const calc = sum % 11;
  const d9 = parseInt(afm[8]);
  const valid = calc % 10 === d9;

  return valid;
};

export const validGEMI = gemi => {
  if (typeof gemi !== 'string') return false;
  const regex = /^(0\d{11}|\d{12})$/;
  return regex.test(gemi);
}

export const validPhoneNumber = (phone, onlyMobile = false, onlyLandline = false) => {
  var phoneFormat = new RegExp(/^[0-9\b]+$/);
  if (!/^\d+$/.test(phone)) {
    // "Αυτό που εισάγετε δεν είναι αριθμός"
    return false;
  }
  if ((phone[0] !== '6' || phone[1] !== '9') && phone[0] !== '2' && (phone[0] !== '9' || phone[1] !== '0' || phone[2] !== '0')) {
    return false;
  }

  if (phone.length !== 10) {
    return false;
  }
  if (onlyMobile && (phone[0] !== '6' || phone[1] !== '9')) {
    return false
  }

  if (onlyLandline && (phone[0] !== '2') && (phone[0] !== '9' || phone[1] !== '0' || phone[2] !== '0')) {
    return false
  }
  if (phone != null && phone.match(phoneFormat)) {
    return true;
  }
};

export const percentageValid = field => {
  if (field >= -1 && field <= 1) {
    return true;
  }
  return false;
};

export const validateAFM = afm => {
  if (afm.length !== 9) {
    // "Τα ψηφία του ΑΦΜ πρέπει να είναι 9 αριθμοί"
    return Promise.reject('Τα ψηφία του Α.Φ.Μ. πρέπει να είναι 9 αριθμοί');
  }

  if (!/^\d+$/.test(afm)) {
    // "Αυτό που εισάγετε δεν είναι αριθμός"
    return Promise.reject('Αυτό που εισάγετε δεν είναι αριθμός');
  }

  if (afm === '0'.repeat(9)) {
    // "Αυτό που εισάγετε είναι μηδενικός αριθμός (000000000)"
    return Promise.reject('Αυτό που εισάγετε δεν είναι έγκυρο Α.Φ.Μ.');
  }
  const sum = afm
    .substring(0, 8)
    .split('')
    .reduce((s, v, i) => s + (parseInt(v) << (8 - i)), 0);

  const calc = sum % 11;
  const d9 = parseInt(afm[8]);
  const valid = calc % 10 === d9;

  return valid
    ? Promise.resolve()
    : Promise.reject('Αυτό που εισάγετε δεν είναι έγκυρο Α.Φ.Μ.');
};

export const validateDate = date => {
  const inputDate = isString(date) ? moment(date) : date;

  if (!inputDate || date.isBefore(new Date(), 'day')) {
    return false;
  } else {
    return true;
  }
};

export const validateBirthDate = (date, promise = false) => {
  const inputDate = isString(date) ? moment(date) : date;
  const lowerLimit = new Date(1924, 0, 1); // 01/01/1924
  const upperLimit = new Date(2010, 11, 31) // 31/12/2010

  if (!inputDate || inputDate.isBefore(lowerLimit, 'day') || inputDate.isAfter(upperLimit, 'day')) {
    return promise ? Promise.reject('Η ημερομηνία είναι εκτός ορίων.') : false;
  }
  else return promise ? Promise.resolve() : true;
}

// website validator
export const validateWebSite = debounce((_, website) => {
  const siteformat = /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(#[-a-z\d_]*)?$/i;

  if (website != null && siteformat.test(website)) {
    return Promise.resolve(); // Website is valid.
  } else {
    return Promise.reject('Αυτό που εισάγετε δεν είναι έγκυρος ιστοχώρος'); // Invalid website.
  }
}, 300);

//Phone Number Validator
export const validatePhoneNumber = (phone, onlyMobile = false, onlyLandline = false) => {
  var valid = false;
  var phoneFormat = new RegExp(/^[0-9\b]+$/);
  if (!/^\d+$/.test(phone)) {
    // "Αυτό που εισάγετε δεν είναι αριθμός"
    return Promise.reject('Αυτό που εισάγετε δεν είναι αριθμός');
  }
  if ((phone[0] !== '6' || phone[1] !== '9') && phone[0] !== '2' && (phone[0] !== '9' || phone[1] !== '0' || phone[2] !== '0')) {
    return Promise.reject(
      'Αυτό που εισάγετε δεν είναι έγκυρος αριθμός τηλεφώνου'
    );
  }

  if (onlyMobile && (phone[0] !== '6' || phone[1] !== '9')) {
    return Promise.reject(
      'Αυτό που εισάγετε δεν είναι έγκυρος αριθμός κινητού τηλεφώνου'
    );
  }

  if (onlyLandline && (phone[0] !== '2') && (phone[0] !== '9' || phone[1] !== '0' || phone[2] !== '0')) {
    return Promise.reject(
      'Αυτό που εισάγετε δεν είναι έγκυρος αριθμός σταθερού τηλεφώνου'
    );
  }

  if (phone.length !== 10) {
    return Promise.reject('Τα ψηφία του τηλεφώνου πρέπει να είναι 10 αριθμοί');
  }
  if (phone != null && phone.match(phoneFormat)) {
    valid = true;
  }
  return valid
    ? Promise.resolve()
    : Promise.reject('Αυτό που εισάγετε δεν είναι έγκυρος αριθμός τηλεφώνου');
};
//todo test validator
export const validateEmail = debounceWithPromise((_, email) => {
  var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  var valid = false;
  if (email != null && email.match(mailformat)) {
    valid = true;
  }
  return valid
    ? Promise.resolve()
    : Promise.reject('Αυτό που εισάγετε δεν είναι έγκυρο email');
}, 300);

export const formattedNumber = (value = 0) => {
  let parts = value.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  // this check is enchanced for showing 2 decimals when the input has only one decimal. (e.g 5.7 will be converted to 5.70)
  // in case of multiple digits int decimal part of number round only the first two
  parts[1] =
    parts.length === 1
      ? '00'
      : Math.round(
        parseFloat(parts[1]) / 10 ** (parts[1].length - 2)
      ).toString();
  return parts.join(',');
};

export const currencyFormatter = (value = 0) => {
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
  }).format(value);
};

export const percentageFormatter = (value = 0) => {
  //console.log(value);
  if (isNil(value) || isNaN(value)) {
    return '0,00%';
  }
  const simpleFormat = new Intl.NumberFormat('de-DE', {
    style: 'percent',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
  let perc = simpleFormat.format(value / 100);
  return perc;
};

export const numberInputFormatter = value => {
  if (value) return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return;
};

export const numberInputParser = value => {
  if (value) return value.replace(/\./g, '');
  return;
};


export const validateDateCompletion = value => {
  const formattedValue = isString(value) ? moment(value) : value;
  let valid = true;

  if (formattedValue.isAfter('2027-01-01')) {
    valid = false;
  }

  return valid
    ? Promise.resolve()
    : Promise.reject(
      'Η εκτιμώμενη ημερομηνία ολοκλήρωσης του ΕΣ χρειάζεται να ειναι έως το 2026'
    );
};

export const validateDateCompletionAfterStart = (value, state) => {
  const formattedValue = isString(value) ? moment(value) : value;
  let valid = true;

  if (formattedValue.isBefore('2022-05-24')) {
    valid = false;
  }

  return valid
    ? Promise.resolve()
    : Promise.reject(
      'Η «Ημ. Έναρξης» να μην είναι μεταγενέστερη της «Ημ. Ολοκλήρωσης». '
    );
};

export function checkDateAfter(value, value_2) {
  var checkDate = new Date(value);
  checkDate.setDate(checkDate.getDate() + 1);
  if (!value_2.isAfter(checkDate)) {
    return true;
  } else {
    return false;
  }
}

export const validateDateStart = value => {
  const formattedValue = isString(value) ? moment(value) : value;
  let valid = true;

  if (
    formattedValue.isBefore(
      new Date(new Date().valueOf())
      //new Date(new Date().valueOf() - 1000 * 60 * 60 * 24)
    )
  ) {
    valid = false;
  }

  return valid
    ? Promise.resolve()
    : Promise.reject(
      'Η ημερομηνία έναρξης του ΕΣ χρειάζεται να ειναι μεγαλύτερη απο την σημερινή'
    );
};

export const getFullIsoDate = date => {
  if (date && moment(date).isValid()) {
    return moment(date).utc().format('DD/MM/YYYY HH:mm:ss');
  }
};

export const readUrlParams = () => {
  return Object.fromEntries(new URLSearchParams(window.location.hash.replace(/.*\?/, "")).entries());
};

const messageCodeMap = {
  forgotPass: "Εάν η διεύθυνση email σας υπάρχει στη βάση δεδομένων μας, θα λάβετε έναν σύνδεσμο ανάκτησης κωδικού πρόσβασης στη διεύθυνση email με περαιτέρω οδηγίες.",
  invalidOperation: "Η συγκεκριμένη ενέργεια δεν είναι έγκυρη πλέον.",
};

export const resolveMessageCode = (code) => {
  if (messageCodeMap[code]) return messageCodeMap[code];
  else return "";
};


export const validateCompliance = checked => {
  let valid = true;

  if (!checked) {
    valid = false;
  }

  return valid
    ? Promise.resolve()
    : Promise.reject(
      <div className="ComplianceErrorMessage">Το πεδίο είναι υποχρεωτικό</div>
    );
};

export const isRejectedStatus = status => {
  if (
    status === 'AS_2B1' // Ενταξη στο Μητρωο Εγκαταστατων
  ) {
    return true;
  }
  return false;
};

export const isCarrierUsersValidSupplier = carrier => {
  const carrierUsers = carrier.carrierUsers;

  console.log("isCarrierUsersValidSupplier ", carrierUsers);
  return !isNil(carrier.carrierUsers)
    ?

    carrier.carrierUsers.every(
      el =>
        !isNil(el.shareholderName) &&
        el.shareholderName !== '' &&
        !isNil(el.shareholderVat) &&
        el.shareholderVat !== '' &&
        !isNil(el.shareholderCountry) &&
        el.shareholderCountry !== '' &&
        !isNil(el.shareholderPercentage) &&
        el.shareholderPercentage !== ''
    )
    : true;
};

export const validSumPercentage = per => {
  var valid = true;

  if (per > 100) {
    valid = false;

    return Promise.reject('Το ποσοστό που εισάγατε είναι μεγαλύτερο του 100%');
  } else if (per < 0) {
    valid = false;

    return Promise.reject('Το ποσοστό που εισάγατε είναι αρνητικό');
  } else if (per == 0) {
    return Promise.reject(
      'Το ποσοστό που εισάγατε πρέπει να είναι μεγαλύτερο του 0.'
    );
  }

  return valid
    ? Promise.resolve()
    : Promise.reject('Το ποσοστό που εισάγατε δεν είναι έγκυρο');
};

export const validPercentage = per => {
  var valid = true;

  if (per > 100) {
    valid = false;

  } else if (per < 0) {
    valid = false;

  } else if (per == 0) {
    valid = false
  }

  return valid;
}

function debounceWithPromise(inner, ms = 0) {
  let timer = null;
  let promises = [];

  return function (...args) {    
    clearTimeout(timer);
    timer = setTimeout(() => {
      const result = inner(...args);
      
      result
        .then(value => {
          promises.forEach(({ resolve }) => resolve(value));
          promises = [];
        })
        .catch(error => {
          promises.forEach(({ reject }) => reject(error));
          promises = [];
        });
    }, ms);

    return new Promise((resolve, reject) => {
      promises.push({ resolve, reject });
    });
  };
}
